import React, { useEffect, useState } from 'react';

import { makeStyles, Typography } from '@material-ui/core';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import moment from 'moment';

import Table from '../common/Table';
import TableEmailCell from '../common/TableEmailCell';
import StatusCell from '../creators/StatusCell';

const buildDateOfBird = (value) => {
  const dateOfBirth = value ? moment.parseZone(value).format('MM/DD/YYYY') : '';

  return <span style={{ color: '#999999' }}>{dateOfBirth !== 'Invalid date' ? dateOfBirth : ''}</span>;
};

const useStyles = makeStyles(() => {
  return {
    buttonContainer: {
      alignItems: 'center',
      display: 'flex',
      gap: '4px',
    },
    buttonInteractionText: {
      color: '#E92828',
      fontSize: '12px',
      lineHeight: '12px',
      textAlign: 'center',
    },
    iconInteractionTrash: {
      color: '#E92828',
      height: '24px',
      width: '24px',
    },
  };
});

function getColumns(onInvitedClick, isMediphanyWorkspace, currentUser, classes, handleDeletePatient) {
  const clinicColumns = [
    { label: 'Name', name: 'name', sort: true },
    {
      label: 'Email Address',
      name: 'email',
      options: {
        customBodyRender: (value) => <TableEmailCell value={value} />,
      },
    },
    {
      label: 'Date of Birth',
      name: 'dateOfBirth',
      options: {
        customBodyRender: buildDateOfBird,
      },
    },
    {
      label: 'Telephone',
      name: 'phoneNumber',
      options: {
        customBodyRender: (value) => <span style={{ color: '#999999' }}>{value}</span>,
      },
    },
    {
      label: 'Status',
      name: 'status',
      options: {
        customBodyRender: (value, meta) => {
          const creatorData = { dateOfBirth: meta.rowData[2], email: meta.rowData[1], id: meta.rowData[5], name: meta.rowData[0], phoneNumber: meta.rowData[3] };
          return <StatusCell value={value} onInvitedClick={() => onInvitedClick(creatorData)} />;
        },
      },
    },
    {
      label: '',
      name: 'id',
      options: { display: false },
    },
  ];

  const mediphanyColumns = [
    {
      label: 'ID',
      name: 'id',
      options: {
        customBodyRender: (value) => <span style={{ display: 'flex', fontWeight: 700, justifyContent: 'center', width: '100%' }}>{value}</span>,
      },
    },
    { label: 'Name', name: 'name', sort: true },
    {
      label: 'Email Address',
      name: 'email',
      options: {
        customBodyRender: (value) => <TableEmailCell value={value} />,
      },
    },
    {
      label: 'Date of Birth',
      name: 'dateOfBirth',
      options: {
        customBodyRender: buildDateOfBird,
      },
    },
    {
      label: 'Telephone',
      name: 'phoneNumber',
      options: {
        customBodyRender: (value) => <span style={{ color: '#999999' }}>{value}</span>,
      },
    },
    {
      label: 'Workspace',
      name: 'workspace',
      options: {
        customBodyRender: (value) => <span style={{ color: '#999999' }}>{value.name}</span>,
        display: currentUser?.role === 'super-admin',
      },
    },
    {
      label: 'Status',
      name: 'status',
      options: {
        customBodyRender: (value, meta) => {
          const creatorData = { dateOfBirth: meta.rowData[2], email: meta.rowData[1], id: meta.rowData[6], name: meta.rowData[0], phoneNumber: meta.rowData[3] };
          return <StatusCell value={value} onInvitedClick={() => onInvitedClick(creatorData)} />;
        },
      },
    },
    {
      label: '',
      name: '',
      options: {
        customBodyRender: (value, meta) => {
          return (
            currentUser?.role === 'super-admin' && (
              <div
                className={classes.buttonContainer}
                onClick={() => handleDeletePatient(meta.rowData[0])}
                onKeyDown={() => null}
                role="button"
                tabIndex={0}
                aria-label="Delete patient"
                title="Delete patient">
                <DeleteOutlinedIcon fontSize="small" className={`${classes.iconInteraction} ${classes.iconInteractionTrash}`} />
              </div>
            )
          );
        },
      },
    },
  ];

  return isMediphanyWorkspace ? mediphanyColumns : clinicColumns;
}

export default ({ currentUser, isMediphanyWorkspace, onInvitedClick, onCriteriaChange, total, patients, onUserDelete }) => {
  const classes = useStyles();

  const defaultOptions = {
    count: total,
    onTableChange: (action, tableState) => {
      const criteria = {};
      switch (action) {
        case 'sort':
          criteria.orderType = tableState.sortOrder.direction.toUpperCase();
          criteria.orderField = tableState.sortOrder.name;
          break;
        case 'changePage':
          criteria.page = tableState.page;
          break;
        case 'changeRowsPerPage':
          criteria.limit = tableState.rowsPerPage;
          setTableOptions({
            ...tableOptions,
            rowsPerPage: tableState.rowsPerPage,
          });
          break;
        default:
          return;
      }
      onCriteriaChange(criteria);
    },
    serverSide: true,
  };

  useEffect(() => {
    setTableOptions({
      ...tableOptions,
      count: total,
    });
  }, [total]);

  const handleDeletePatient = async (patientId) => {
    await onUserDelete(patientId);
  };

  const columns = getColumns(onInvitedClick, isMediphanyWorkspace, currentUser, classes, handleDeletePatient);
  const [tableOptions, setTableOptions] = useState(defaultOptions);

  return <Table columns={columns} data={patients || []} options={tableOptions} />;
};
